import { useMemo } from "react"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { NEEDS_DESIGN_STYLES } from "../../utils/dev"
import { Designation, StripePaymentMethod } from "../types"
import { coveredFeeCents } from "../utils/coverTheFee"
import { formattedCents } from "source/giving/utils/money"

interface CoverTheFeeProps {
  designations: Designation[]
  feeCovered: boolean
  stripePaymentMethod: StripePaymentMethod
}

export function CoverTheFee({
  designations,
  feeCovered,
  stripePaymentMethod,
}: CoverTheFeeProps) {
  const { config, dispatch } = useDonationFormContext()
  const feeDollars = useMemo(
    () =>
      formattedCents(
        coveredFeeCents(config, designations, stripePaymentMethod.type),
      ),
    [config, designations, stripePaymentMethod.type],
  )
  const showBankComparison = stripePaymentMethod.type === "card"
  return (
    <div>
      <label style={NEEDS_DESIGN_STYLES}>
        <input
          type="checkbox"
          checked={feeCovered}
          onChange={(event) => {
            dispatch({
              type: "SET_FEE_COVERED",
              feeCovered: event.target.checked,
            })
          }}
        />
        I&rsquo;d like to cover the {feeDollars} processing fee
      </label>
      {showBankComparison && <BankFeeComparison {...{ designations }} />}
    </div>
  )
}

function BankFeeComparison({ designations }: { designations: Designation[] }) {
  const { config } = useDonationFormContext()
  const bankFeeDollars = useMemo(
    () => formattedCents(coveredFeeCents(config, designations, "bank")),
    [config, designations],
  )
  return (
    <small style={NEEDS_DESIGN_STYLES}>
      Fees are only {bankFeeDollars} for ACH bank transfers
    </small>
  )
}
